function handleCheckboxChange(e) {
    console.log("Changed");
	const vatInputContainer = document.getElementById("vat-input-container");
	const vatInput = document.getElementById("vat-number");
	vatInput.value = "";

    toggleCheckoutButtonDisabledState(e.target.checked);
	vatInputContainer.style.display = e.target.checked ? "flex" : "none";
	vatInput.required = e.target.checked;
}

function isVatNumberValid(vatNumber) {
	const euVatRegex =
		/^(ATU[0-9]{8}|BE[01][0-9]{9}|BG[0-9]{9,10}|HR[0-9]{11}|CY[A-Z0-9]{9}|CZ[0-9]{8,10}|DK[0-9]{8}|EE[0-9]{9}|FI[0-9]{8}|FR[0-9A-Z]{2}[0-9]{9}|GB[0-9]{12}|GB[0-9]{9}|DE[0-9]{9}|EL[0-9]{9}|ESX[0-9]{9}[A-Z]{1}|HU[0-9]{8}|IE([0-9]{7}[A-Z]{1,2}|[0-9][A-Z][0-9]{5}[A-Z])|IT[0-9]{11}|LV[0-9]{11}|LT([0-9]{9}|[0-9]{12})|LU[0-9]{8}|MT[0-9]{8}|NL[0-9]{9}B[0-9]{2}|PL[0-9]{10}|PT[0-9]{9}|RO[0-9]{2,10}|SK[0-9]{10}|SI[0-9]{8}|ES[A-Z]([0-9]{8}|[0-9]{7}[A-Z])|SE[0-9]{12}|GB([0-9]{9}|[0-9]{12}|GD[0-4][0-9]{2}|HA[5-9][0-9]{2}))$/;
	const huVatRegex = /^([0-9]{8})-([0-9]{1})-([0-9]{2})$/;
	const trimmedVatNumber = vatNumber.trim();
	return euVatRegex.test(trimmedVatNumber) || huVatRegex.test(trimmedVatNumber);
}

function toggleCheckoutButtonDisabledState(disabled) {
	const checkoutButton = document.querySelector(".cart-order a[name='checkout']");

	if (checkoutButton) {
		checkoutButton.ariaDisabled = `${disabled}`;

		if (disabled) {
			checkoutButton.classList.add("pointer-events-none");
		}

		if (!disabled) {
			checkoutButton.classList.remove("pointer-events-none");
		}
	}
}

function handleVatInputChange(e) {
	const isValid = isVatNumberValid(e.target.value);

	// @ts-ignore
	fetch(window.Shopify.routes.root + "cart/update.js", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			attributes: {
				"VAT Number": isValid ? e.target.value : "",
			},
		}),
	}).then(() => toggleCheckoutButtonDisabledState(!isValid));
}

let listenersAttached = false;

function attachEventListeners() {
	const businessCheckbox = document.getElementById("business-checkbox");
	const vatInput = document.getElementById("vat-number");

	if (!businessCheckbox || !vatInput) {
		return;
	}

	if (listenersAttached) {
		businessCheckbox.removeEventListener("change", handleCheckboxChange);
		vatInput.removeEventListener("input", handleVatInputChange);
		listenersAttached = false;
	}

	businessCheckbox.addEventListener("change", handleCheckboxChange);
	vatInput.addEventListener("input", handleVatInputChange);
	listenersAttached = true;
}


document.addEventListener("DOMContentLoaded", () => {
	attachEventListeners();
});
